<template>
    <div class="TargetBehaviorEditor">
        <!--DISPLAY TABLE-->
        
            <b-row>
                <b-col cols="11">
                    <vuetable :fields="TableFields"
                              :data="TargetBehaviors"
                              pagination-path=""
                              :api-mode="false"
                              class="vue-datatable"
                              :row-class="onRowClass">

                        <template slot="DetailView" scope="props">
                            <div class="DetailView">
                                <span class="underline pointer" @click="ShowDetailView(props.rowData)"><span v-html="props.rowData.BehaviorDescription"></span> <font-awesome-icon :icon="['fa', 'edit']" v-if="EditMode" /></span>
                            </div>
                        </template>
                    </vuetable>
                </b-col>
                <b-col cols="1">
                    <div v-if="EditMode" class="vert-icons">
                        <b-row>
                            <font-awesome-icon :icon="['fa', 'plus']" v-on:click="ShowAddEdit()" class="pointer olive-green-text" />
                        </b-row>
                    </div>
                </b-col>
            </b-row>
        

        <!--ADD AND EDIT AND DETAIL MODAL-->
        <b-modal ref="modal-component" size="lg" :title="ModalTitle" hide-footer>
            <b-container v-if="EditMode == false && TargetBehavior.Id">
                <b-row>
                    <b-col>
                        <h3>Info</h3>
                        <p><span class="bold">Description: </span>{{TargetBehavior.BehaviorDescription}}</p>
                        <p><span class="bold">Misc Notes: </span>{{TargetBehavior.MiscNotes}}</p>
                    </b-col>
                    <b-col>
                        <h3>Start/End</h3>
                        <p><span class="bold">Start Date: </span>{{ formatDate(TargetBehavior.StartDate,'MM/DD/YY') }}</p>
                        <p><span class="bold">End Date: </span>{{ formatDate(TargetBehavior.EndDate,'MM/DD/YY') }}</p>
                    </b-col>
                </b-row>
                <b-row class="modal-btn-row">
                    <div class="modal-btn-row-div">
                        <b-button size="md" variant="secondary" @click="Cancel()">
                            CLOSE
                        </b-button>
                    </div>
                </b-row>
            </b-container>
            <b-container v-if="EditMode">
                <b-form @submit="AddEdit" autocomplete="off">
                    <b-row>
                        <b-col>
                            <h3>Info</h3>
                            <div class="form-group">
                                <label>Behavior Description:</label>
                                <textarea cols="6" class="form-control" v-model="TargetBehavior.BehaviorDescription" required></textarea>
                            </div>
                            <div class="form-group">
                                <label>Misc Notes:</label>
                                <textarea cols="6" class="form-control" v-model="TargetBehavior.MiscNotes"></textarea>
                            </div>
                        </b-col>
                        <b-col>
                            <h3>Start/End</h3>
                            <div class="form-group">
                                <label>Start Date:</label>
                                <flat-pickr v-model="TargetBehavior.StartDate" class="form-control" required :config="DateConfig"></flat-pickr>
                            </div>
                            <div class="form-group">
                                <label>End Date:</label>
                                <flat-pickr v-model="TargetBehavior.EndDate" class="form-control" :config="DateConfig"></flat-pickr>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">
                            <b-button size="md" variant="secondary" @click="Cancel()">
                                CANCEL
                            </b-button>
                            <b-button size="md" variant="success" type="submit" v-if="EditMode">
                                SAVE
                            </b-button>
                            <b-button size="md" variant="danger" @click="Delete()" type="button" v-if="TargetBehavior.Id">
                                DELETE
                            </b-button>
                        </div>
                    </b-row>
                </b-form>
            </b-container>
        </b-modal>
    </div>
</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faPlus } from '@fortawesome/free-solid-svg-icons';
    library.add(faPlus);
    import { faEdit } from '@fortawesome/free-solid-svg-icons';
    library.add(faEdit);
    //import components
    import { EventBus } from '../../../../services/event-bus.js';

    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';

    import Vuetable from 'vuetable-2/src/components/Vuetable';

    export default {
        props: [
            "RecordId",
            "EditMode"//bool
        ],
        data: function () {
            return {
                TargetBehaviors: [],
                TargetBehavior: {},
                TargetBehaviorSchema: {
                    ClientSubProgramMembershipID: "",
                    BehaviorDescription: "",
                    MiscNotes: "",
                    StartDate: "",
                    EndDate: ""
                },
                TableFields: [
                    {
                        name: "__slot:DetailView",
                        title: "Description"
                    },
                    {
                        name: "StartDate",
                        title: "STARTED",
                        callback: 'formatDate|MM/DD/YY'
                    },
                    {
                        name: "EndDate",
                        title: "ENDED",
                        callback: 'formatDate|MM/DD/YY',
                    }
                ],
                DateConfig: {
                    dateFormat: 'Y-m-d',
                    allowInput: true,
                    altInput: true,
                    altFormat: 'm/d/Y',
                    required: false
                }
            };
        },
        methods: {
            GetTargetBehaviors() {
                this.$MasterAPI.ExecuteRequest("GET", "Residential/Clients/TargetBehaviors/GetTargetBehaviors", { Id: this.RecordId }, this.GetTargetBehaviorsSuccess, () => { }, false);
            },
            GetTargetBehaviorsSuccess(response) {
                this.TargetBehaviors = response.data.data;
            },
            ShowDetailView(tb) {
                this.TargetBehavior = JSON.parse(JSON.stringify(tb));

                if (this.EditMode) {
                    this.ModalTitle = "Editing Target Behavior"
                } else {
                    this.ModalTitle = "Viewing Target Behavior"
                }
                this.$refs["modal-component"].show();
            },
            ShowAddEdit() {
                this.TargetBehavior = JSON.parse(JSON.stringify(this.TargetBehaviorSchema));
                this.TargetBehavior.ClientSubProgramMembershipID = this.RecordId;
                this.ModalTitle = "Add New Target Behavior";
                this.$refs["modal-component"].show();
            },
            AddEdit(e) {
                e.preventDefault();
                this.$MasterAPI.ExecuteRequest("POST", "Residential/Clients/TargetBehaviors/AddOrUpdateClientTargetBehaviors", this.TargetBehavior, this.AddEditSuccess, () => { }, true);
            },
            AddEditSuccess(response) {
                this.GetTargetBehaviors();
                this.$refs["modal-component"].hide();
            },
            Delete() {
                this.$MasterAPI.ExecuteRequest("POST", "Residential/Clients/TargetBehaviors/DeleteClientTargetBehavior", { Id: this.TargetBehavior.Id }, this.DeleteSuccess, () => { }, true);
            },
            DeleteSuccess(response) {
                this.GetTargetBehaviors();
                this.$refs["modal-component"].hide();
            },
            Cancel() {
                this.$refs['modal-component'].hide();
            },
            onRowClass(dataItem, index) {
                return (dataItem.EndDate == null) ? 'current-record' : '';
            },
            formatDate(value, fmt = 'MM/DD/YY', defaultText = '') {
                return (value == null)
                    ? defaultText
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            }
        },
        components: {
            Vuetable,
            flatPickr
        },
        mounted() {
            this.GetTargetBehaviors();
        },
        computed: {
            
        }    
    }
</script>

<style scoped>
    .vert-icons div {
        margin-top: 10px;
    }

    /deep/ tbody tr.current-record {
        font-weight: bold;
    }

    table {
        table-layout: auto;
    }

    .vue-datatable {
        width: 100%;
        display: inline-table;
        overflow-x: auto;
    }
</style>